<script lang="ts">
	import { Image, OutboundLink, RadioButtonSingle, Tooltip } from '@cf/ui-lib';
	import { BackArrow, StarIcon } from '@cf/ui-lib/icons';
	import { BrandStatusEnum } from '@cf/ui-lib/typings';
	import BreadCrump from './breadCrump.svelte';

	export let src = '';
	export let title;
	export let backUrl: string = '';
	export let showimage = false;
	export let isStatus = false;
	export let is_rating = false;
</script>

<div class="flex w-full items-center gap-2.5">
	<OutboundLink href={backUrl}><BackArrow /></OutboundLink>
	{#if showimage}
		<div
			class="relative h-[62px] w-[113px] overflow-hidden rounded-md border border-solid border-border"
		>
			<Image {src} class="h-full w-full rounded-md object-cover object-center" />
		</div>
	{/if}
	<BreadCrump data={title} />
	

	{#if isStatus}
		<slot />
	{/if}
</div>
